import { Collection } from '../UniversalLanding/utils';

// Update table numer cards
export const TableNumberCollections: Collection[] = [
  {
    uuid: '9dfd7296-5d45-4342-b16f-9de805516f18',
    card: 'Goundry',
    color: 'Light Oatmeal',
  },
  {
    uuid: '15f66c3d-4ff0-4c8d-9929-5fb89d9ce9ff',
    card: 'Deepcreek',
    color: 'Spring',
  },
  {
    uuid: '43808242-c920-472c-8c1c-b4dad54538a1',
    card: 'Buxton',
    color: 'Light Tan',
  },
];

export const PlaceCardCollections: Collection[] = [
  {
    uuid: '8b8b7a3e-8f98-4717-a75a-4b9c768d3232',
    card: 'Deepcreek',
    color: 'Spring',
  },
  {
    uuid: 'c0f537f3-f982-4b52-a286-17e815f4feea',
    card: 'Brenton',
    color: 'Ebony',
  },
  {
    uuid: 'ed8c3a69-2045-4845-9f54-0b763f74eca4',
    card: 'Kalispell',
    color: 'Forest',
  },
];

export const MenusCollections: Collection[] = [
  {
    uuid: 'f3ccc865-c970-420e-85d4-08f9c02b3df3',
    card: 'Windsong',
    color: 'Off-White',
  },
  {
    uuid: 'd719daff-e4d1-4e17-8ce1-4537b1897367',
    card: 'Brevard',
    color: 'Dark Emerald',
  },
  {
    uuid: 'a6c9f683-e856-4e2d-ae93-0f822f8137f3',
    card: 'Staton',
    color: 'Emerald Forest',
  },
];

export const ProgramsCollections: Collection[] = [
  {
    uuid: 'f6d0b33a-8d07-4468-9f66-fc2d9b93df98',
    card: 'Misty Foil',
    color: 'Powder Blue',
  },
  {
    uuid: 'f984e50f-6b1a-42ac-8165-a1a41c60b1ad',
    card: 'Deep Creek',
    color: 'Fall',
  },
  {
    uuid: 'df95c80b-98ee-4a9c-a75e-0402e4a0eb6f',
    card: 'Ybel',
    color: 'White',
  },
];
